<template>
    <div class="mailMessage">
        <div class="searchForm">
            <el-form ref="form" :model="form" label-width="75px" @submit.native.prevent>
              
                        <el-form-item label="批次号" label-width="60px">
                            <el-input v-model="form.batchNumber" autocomplete="off" placeholder="批次号"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                   
                        <el-form-item label="标题" label-width="50px">
                            <el-input v-model="form.title" autocomplete="off" placeholder="标题"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                  
                        <el-form-item label="收件地址">
                            <el-input v-model="form.mail" autocomplete="off" placeholder="收件地址"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                        <el-form-item label="发件地址">
                            <el-input v-model="form.sender" autocomplete="off" placeholder="发件地址"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                   
                        <el-form-item label="发送日期">
                            <el-date-picker v-model="form.sendTime" type="datetimerange" size="small"
                                :picker-options="pickerOptions" range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" align="right">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="邮件ID" label-width="60px">
                            <el-input v-model="form.mailMessageId" autocomplete="off" placeholder="收件地址"
                                @keyup.enter.native="getMessageList(1)" />
                        </el-form-item>
                        <el-form-item label="发送状态">
                            <el-select v-model="form.status" placeholder="请选择发送状态" clearable @change="getMessageList(1)">
                                <el-option label="全部" value="" />
                                <el-option label="发送成功" value="1" />
                                <el-option label="发送失败" value="2" />
                                <el-option label="待发送" value="3" />
                                <el-option label="发送异常" value="4" />
                                <el-option label="消息拦截" value="5"/>
                            </el-select>
                        </el-form-item>
                        <el-button style="margin-left: 20px" type="primary" @click="getMessageList(1)">查询</el-button>
               
            </el-form>
        </div>
        <div class="dataBox">
            <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe  max-height="700">
                <el-table-column type="expand">
                    <template slot-scope="scope">
                        <el-form label-position="left" class="table-expand">
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">邮件查询id</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.mailMessageId }}</el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="batchNumber" label="消息批次号" width="200" />
                <el-table-column prop="title" show-overflow-tooltip label="标题" />
                <el-table-column prop="templateCode" label="模板编码" width="140" />
                <el-table-column prop="sender" label="发件地址" width="300" />
                <el-table-column prop="mail" label="收件地址" width="300" />
                <el-table-column prop="mailType" label="收件类型" width="140">
                    <template slot-scope="scope">
                        <span>{{ parseMailType(scope.row.mailType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendTime" sortable label="发送时间" width="200">
                    <template slot-scope="scope">
                        <span>{{ parseTime(scope.row.sendTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="发送状态" width="140">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.status === 1 ? 'success' : (scope.row.status === 2 || scope.row.status === 5) ? 'danger' : scope.row.status === 3 ? 'info' : 'warning'">
                            {{ parseStatus(scope.row.status) }}
                        </el-tag>
                        <i v-if="scope.row.status === 2 && scope.row.mailMessageId !== null || scope.row.status === 4 && scope.row.mailMessageId !== null"
                            @click="detiallist(scope.row.mailMessageId)" class="el-icon-warning-outline btnclass"></i>
                        <i v-else-if="scope.row.status === 5 && scope.row.batchNumber"
                            @click="handleStatusDetail(scope.row.batchNumber)" class="el-icon-warning-outline btnclass"></i>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-sizes="[10, 20, 50]" :page-size="pageSize" :current-page.sync="pageNum" @size-change="sizeChangeClick"
                @current-change="currChangeClick" @prev-click="prevClick" @next-click="nextClick" />
        </div>
        <!-- 警告详情 -->
        <div>
            <el-dialog title="发送状态详情" :visible.sync="dialogVisible" width="35%">
                <div>
                    <p>{{ detialcontent }}</p>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { parsePriority } from "@/util/index";
import { parseTime } from "@/util/index";
import httpUrl from "@/static/configUrl";

export default {
    name: "mailMessage",
    components: {},
    data() {
        return {
            dialogVisible: false,
            detialcontent: '',
            // clientId: this.$store.state.request.appId,
            form: {
                batchNumber: '',
                title: '',
                sender: '',
                mailMessageId: '',
                mail: '',
                searchParam: '',
                type: 3,
                status: '',
                sendTime: []
            },
            startTime: '',
            endTime: '',
            pickerOptions: {
                 onPick: ({ maxDate, minDate }) => {
                    if (minDate && !maxDate) {
                        this.$set(this, 'selectDate', minDate.getTime())
                    } else {
                        this.$set(this, 'selectDate', '')
                    }
                },
                disabledDate: (time) => {
                    if (this.selectDate) {
                        const maxTime = this.selectDate + 30 * 24 * 3600 * 1000
                        const minTime = this.selectDate - 30 * 24 * 3600 * 1000
                        return time.getTime() > maxTime || time.getTime() < minTime
                    }
                    return false
                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            selectDate: '',
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            loading: false,
            dialogEditFormVisible: false,
            dialogFormVisible: false,
        }
    },
    computed: {
        clientId(){
            return this.$store.state.request.appId
        }
    },
    watch:{
        clientId() {
            this.getMessageList()
        }
    },
    created() {
        this.initDatePickValue()
        this.getMessageList()
    }
    ,
    mounted() {
    }
    ,
    methods: {
        parseTime,
        parsePriority,
        parseStatus(status) {
            switch (status) {
                case 1:
                    return "发送成功"
                case 2:
                    return "发送失败"
                case 3:
                    return "等待发送"
                case 4:
                    return "发送异常"
                case 5:
                    return "消息拦截"
                default:
                    return "未知状态"
            }
        },
        parseMailType(mailType) {
            switch (mailType) {
                case 0:
                    return "主送"
                case 1:
                    return "抄送"
                case 2:
                    return "密送"
                default:
                    return ""
            }
        },
        formartTime(date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            var minute = date.getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            var second = date.getSeconds();
            second = second < 10 ? ('0' + second) : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        getMessageList(_pageNum) {
            const that = this
            if (_pageNum === 1) {
                that.pageNum = 1
            }
            that.loading = true
            const _data = {
                curl: httpUrl.messageUrl + '/message/list',
                sendTime: that.form.sendTime,
                clientId: that.clientId,
                batchNumber: that.form.batchNumber,
                title: that.form.title,
                sender: that.form.sender,
                mailMessageId: that.form.mailMessageId,
                mail: that.form.mail,
                // searchParam: that.form.searchParam,
                status: that.form.status,
                type: that.form.type,
                page: that.pageNum,
                size: that.pageSize
            }
            that.$store.dispatch('httpPost', _data).then(function (res) {
                that.tableData = res.data.content
                that.total = parseInt(res.data.total)
                that.loading = false
            }, function (err) {
                console.log(err.message)
                that.loading = false
            })
        }
        ,
        // 分页 每页条数改变
        sizeChangeClick(val) {
            this.pageSize = val
            this.getMessageList()
        }
        ,
        // 分页 改变当前页
        currChangeClick(val) {
            this.pageNum = val
            this.getMessageList()
        }
        ,
        // 分页 上一页
        prevClick(val) {
            this.pageNum = val
            this.getMessageList()
        }
        ,
        // 分页 下一页
        nextClick(val) {
            this.pageNum = val
            this.getMessageList()
        },
        initDatePickValue() {
            let d = new Date
            this.form.sendTime.push(d)
            let startTime = d.getTime() - 3600 * 1000 * 24 * 7;
            let startDate = new Date(startTime)
            this.form.sendTime.unshift(startDate)
        },
        // 警告详情
        detiallist(id) {
            if (id) {
                const that = this
                const _data = {
                    curl: httpUrl.messageUrl + '/message/status/' + id,
                }
                that.$store.dispatch('httpGet', _data).then(function (res) {
                    that.detialcontent = res.message
                    that.dialogVisible = true
                }, function (err) {
                    console.log(err.message)
                })
            }
        },
        // 消息拦截详情
        handleStatusDetail(batchNumber) {
            const _data = {
                curl: httpUrl.messageUrl + '/message/intercept/reason/' + batchNumber
            }
            this.$store.dispatch('httpGet', _data).then((res) => {
                this.$alert(res.data.comments, '发送状态详情')
            }, function (err) {
                console.log(err.message)
            })
        }
    }
    ,

}
</script>

<style lang="scss" scoped>
.mailMessage {
    .searchForm {
        /*background: #fff;*/
        /*padding-top: 10px;*/
        padding-left: 10px;

        /*height: 45px;*/
        .el-input {
            width: 200px;
        }
    }
}
</style>
<style>
.mailMessage .searchForm .el-form-item {
    display: inline-block;
}

.mailMessage .searchForm .el-form-item:nth-child(2) {
    margin-left: 30px;
}

.mailMessage .table-expand {
    font-size: 0;
}

.mailMessage .table-expand .expandLabel {
    width: 90px;
    color: #99a9bf;
}

.mailMessage .table-expand .expandContent {
    word-break: break-all;
}

.mailMessage .table-expand .el-form-item {
    margin-left: 50px;
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}

.btnclass {
    cursor: pointer;
    color: #f56c6c;
}
</style>
